import React from 'react';
import './GardenModal.css';

function GardenModal({ isOpen, type = 'alert', title, message, onConfirm, onCancel }) {
  if (!isOpen) return null;
  return (
    <div className="garden-modal-overlay">
      <div className="garden-modal-dialog">
        <div className="garden-modal-header">
          {title || (type === 'confirm' ? 'Are you sure?' : 'Yardray')}
        </div>
        <div className="garden-modal-body">
          {message}
        </div>
        <div className="garden-modal-footer">
          {type === 'confirm' && (
            <button onClick={onCancel} className="garden-modal-btn garden-modal-btn--cancel">
              Cancel
            </button>
          )}
          <button onClick={onConfirm} className="garden-modal-btn garden-modal-btn--confirm">
            {type === 'confirm' ? 'Confirm' : 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default GardenModal;
